import { render, staticRenderFns } from "./createComment.vue?vue&type=template&id=f9515b08&scoped=true&"
import script from "./createComment.vue?vue&type=script&lang=js&"
export * from "./createComment.vue?vue&type=script&lang=js&"
import style0 from "./createComment.vue?vue&type=style&index=0&id=f9515b08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9515b08",
  null
  
)

export default component.exports